import { render, staticRenderFns } from "./detailsModal.vue?vue&type=template&id=728cf640"
import script from "./detailsModal.vue?vue&type=script&lang=js"
export * from "./detailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports